module.exports = __webpack_public_path__ + "img/bg.29584d2b.png";